import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isPriviliged } from '../../../core/deviceHelper';
import s from '../Popup.css';
import { setDeviceCommandValue, removeProtectedInstallation } from '../../../actions/device';
import Icon from '../../Icon';
import Loader from '../../Loader';

import {
	ONLY_DEVICE_CONNECTION,
    DEVICE_PLUS_SERVICE_CONNECTION,
    ONLY_SERVICE_CONNECTION
} from './utils';


class ConnectedDevicesCommon extends React.Component {
	getValue = (item, field) => {
		let value = null;
		try{
			value = item.get(field)
		}catch (error){
			value = item[field]
		}
		return value
	}
	
	showText = (item, userRole) => {
		const isPriviligedUser = isPriviliged(userRole);
		const iconSize = 20;
		const id = this.getValue(item, 'id');
		const serial = this.getValue(item, 'serial');
		let haveInstallation = null;

		switch(this.getValue(item, 'type')){
			case ONLY_DEVICE_CONNECTION:
				haveInstallation = cx(s.marginRight, s.red_text)
				break;
			case DEVICE_PLUS_SERVICE_CONNECTION:
				haveInstallation = cx(s.marginRight, s.green_text)
				break;
			case ONLY_SERVICE_CONNECTION:
				haveInstallation = cx(s.marginRight, s.orange_text)
				break;
			default:
				haveInstallation = cx(s.marginRight)
				break;
		}

		return (
		  <span>
		    <span className={haveInstallation}>
		      <li>{serial}
		        { isPriviligedUser ? (
		          <div
		            className={s.iconWrapper}
		            onClick={() => {
		              this.deleteDevice(id, serial);
		            }}
		          >
		            <Icon iconName={'kosz'} size={iconSize} small />
		          </div> 
		          ) : null 
		        }
		      </li>
		    </span>
		  </span>
		);
	}
	
}




export default ConnectedDevicesCommon;



// WEBPACK FOOTER //
// ./src/components/Popup/DevicePopups/ConnectedDevicesCommon.js